import { render } from "./MarriageView.vue?vue&type=template&id=ef0ba1ea"
import script from "./MarriageView.vue?vue&type=script&lang=js"
export * from "./MarriageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__